import React from 'react'

const SvgImcFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.816 14.142v1.733H2v-1.733h.906V9.858H2V8.125h3.816v1.733H4.91v4.284h.906zm6.538-2.105l-1.58 2.973-.208-.399-1.344-2.575-.113-.242v4.08H7.196V8.126H9.2l1.585 3.139 1.566-3.139h2.014v7.75h-1.913v-4.041l-.098.203v-.001zM19.048 16c-.507 0-.967-.084-1.38-.252a2.793 2.793 0 01-1.065-.763 3.482 3.482 0 01-.67-1.24c-.156-.487-.233-1.051-.233-1.693 0-.634.077-1.201.232-1.701.156-.505.379-.932.668-1.28.292-.352.647-.62 1.064-.8A3.415 3.415 0 0119.048 8c.694 0 1.276.149 1.74.45.465.302.832.772 1.105 1.403l.085.197-1.763.948-.085-.275a1.403 1.403 0 00-.373-.632c-.15-.139-.382-.213-.71-.213-.384 0-.68.125-.906.376-.228.254-.347.638-.347 1.162v1.168c0 .524.119.908.347 1.162.226.251.522.376.907.376.318 0 .56-.086.738-.254.198-.186.343-.41.438-.675l.098-.271L22 13.932l-.09.19c-.279.592-.648 1.054-1.11 1.38-.468.333-1.055.498-1.752.498z'
    />
  </svg>
)

export default SvgImcFilled
